import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-page-privacy-statement',
    templateUrl: './page-privacy-statement.component.html',
    styleUrls: ['./page-privacy-statement.component.scss'],
    standalone: false
})
export class PagePrivacyStatementComponent implements OnInit {

  constructor(public translate: TranslateService) { }

  ngOnInit(): void {
  }

}
